import { ApplicationConfig, inject, isDevMode, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { OCCUPE_MISE_A_JOUR, PURGEURS, STOCKAGE_CATALOGUE, initialiserInstallationPwa, initialiserMiseAJour } from '@stockflow/offline-core';
import { OperationsEnCours } from './core/services/operations-en-cours';
import { StockageCatalogueRxdb } from './core/db/stockage-catalogue-rxdb';
import { PURGEURS_VENTE } from './core/services/purgeurs-vente';

registerLocaleData(localeFr);
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // `beforeinstallprompt` n'est emis qu'une fois : le service d'installation doit exister AVANT le premier
    // ecran, sans quoi l'ecran de connexion ne le voit jamais.
    provideAppInitializer(initialiserInstallationPwa),
    // La mise a jour attend la fin d'une vente qui part : jamais de rechargement au milieu d'un encaissement.
    { provide: OCCUPE_MISE_A_JOUR, useFactory: () => inject(OperationsEnCours).occupe },
    provideAppInitializer(initialiserMiseAJour),
    { provide: PURGEURS, useValue: PURGEURS_VENTE },
    // Le catalogue hors ligne vit dans la base chiffree par le PIN, plus dans localStorage.
    { provide: STOCKAGE_CATALOGUE, useExisting: StockageCatalogueRxdb },
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideTranslateService({
      defaultLanguage: 'ht',
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    /**
     * PWA installable (MOB-014) — manifest.webmanifest et les icones
     * existaient deja en statique, jamais raccordes. `registerWhenStable`
     * attend que l'app finisse de se stabiliser (chargement initial du
     * catalogue POS compris) avant d'enregistrer le worker, pour ne pas
     * concurrencer les vrais appels reseau du demarrage.
     */
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]
};
